'use client';

import { NavigationDrawerLevel, NavigationDrawerList } from '@vs-shop/commerce-ui/navigationDrawer';
import type { ReactNode } from 'react';

import MobileNavigationItem from './MobileNavigationItem';
import MobileNavigationViewAllButton from './MobileNavigationViewAllButton';

import type { TaxonMenu } from '../../../../effect/schema/openapi/backend';

type Props = {
  taxonUrl: string | null;
  onViewAllClickAction: (taxonUrl: string) => void;
  taxonChildren: readonly TaxonMenu[];
  onTaxonChildClickAction: (taxon: TaxonMenu) => void;
  isLoadingChildrenAction: (taxonCode: string) => boolean;
  specialEventsLinks?: ReactNode | null;
};

export default function MobileNavigationLevel({
  taxonUrl,
  onViewAllClickAction,
  taxonChildren,
  onTaxonChildClickAction,
  isLoadingChildrenAction,
  specialEventsLinks,
}: Props) {
  return (
    <NavigationDrawerLevel>
      <NavigationDrawerList>
        {taxonUrl !== null ? (
          <MobileNavigationViewAllButton
            onViewAllClickAction={() => {
              onViewAllClickAction(taxonUrl);
            }}
          />
        ) : null}
        {taxonChildren.map((taxonChild) => (
          <MobileNavigationItem
            key={taxonChild.slug}
            taxon={taxonChild}
            isLoading={isLoadingChildrenAction(taxonChild.code)}
            onClickAction={() => {
              onTaxonChildClickAction(taxonChild);
            }}
          />
        ))}
        {specialEventsLinks}
      </NavigationDrawerList>
    </NavigationDrawerLevel>
  );
}
